import { AppStore, cobdsStore } from "@/lib/store";
import { useRef } from "react";

export function useStoreRef(): AppStore {
  const storeRef = useRef<AppStore | null>(null);

  if (!storeRef.current) {
    storeRef.current = cobdsStore();
  }

  return storeRef.current;
}
